import { ButtonType } from 'antd/lib/button';
import * as React from 'react';
import { ISimpleFileUploadProps } from 'ui-lib/components/fileupload';

export interface ISimpleFileUploadConfig {
    uploadButton?: {
        label: string;
        type?: ButtonType;
    };
    limitFileSize?: number;
    allowedFileTypes?: string[];
    multiple?: boolean;
    afterFileListChange?: (files: File[]) => void;
}
export interface ISimpleFileUploadItemProps {
    hasFileError: boolean;
    files: File[];
    setFiles: (files: File[]) => void;
    getFileUploadProps: () => ISimpleFileUploadProps;
}
export const useSimpleFileUploadProps = (config?: ISimpleFileUploadConfig): ISimpleFileUploadItemProps => {
    const {
        limitFileSize,
        allowedFileTypes,
        multiple,
        uploadButton = { label: 'Select Files', type: 'primary' },
    } = config || {};
    const [fileList, setFileList] = React.useState<File[]>([]);
    const [hasFileError, setHasFileError] = React.useState<boolean>(false);

    const setFiles = (files: File[]): void => {
        setFileList(files);
        config?.afterFileListChange?.(files);
    };

    return {
        hasFileError: hasFileError,
        files: fileList,
        setFiles,
        getFileUploadProps: () => ({
            fileList: fileList,
            setFileList: setFiles,
            allowedFileTypes: allowedFileTypes,
            limitFileSize: limitFileSize,
            setFileError: setHasFileError,
            multiple: multiple,
            button: uploadButton,
        }),
    };
};
